import { render, staticRenderFns } from "./MspForsageOrders.vue?vue&type=template&id=1b145086"
import script from "./MspForsageOrders.vue?vue&type=script&lang=js"
export * from "./MspForsageOrders.vue?vue&type=script&lang=js"
import style0 from "./MspForsageOrders.vue?vue&type=style&index=0&id=1b145086&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports